import React from 'react';
import LocationContent from '../content/LocationContent';
import {useLocation} from '../../../api/hooks';
import Loader from '../Loader';
import PageNotFound from '../PageNotFound';
import Error from '../Error';

export const LocationSelector = ({match, children}) => {
    const {data: location, isLoading, error} = useLocation(match.params.id);

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    return children({location});
};

const Location = ({match}) => (
    <LocationSelector match={match}>
        {({location}) => (
            <>
                {location.error || location.node ? <PageNotFound error={location} />
                    :
                    <>
                        <LocationContent location={location} />
                    </>
                }
            </>
        )}
    </LocationSelector>
);

export default Location;
